import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { Routes } from 'constants/routes.constants';
import { useStorageState } from 'hooks/useStorageState';
import { TICKET_SHARE_CODE_KEY } from 'restful/tickets';

export const useQueryShareCode = () => {
  const { query, isReady, replace } = useRouter();
  const queryShareCode = query['shareCode'] as string;
  const [shareCode, setShareCode] = useStorageState(TICKET_SHARE_CODE_KEY, {
    defaultValue: '',
    engine: 'localStorage',
  });

  useEffect(() => {
    if (isReady && !!queryShareCode) {
      replace({ pathname: Routes.AcceptTransfer }, undefined, {
        shallow: true,
      });
      if (shareCode !== queryShareCode) setShareCode(queryShareCode);
    }
  });

  return shareCode || queryShareCode;
};
